import { object, string } from "yup";

export type VendorManagementCompanySetting = {
	cautionaryNote: string;
	noteTemplate: string | null;
	noteWithinVendor: string | null;
};

export const validationSchema = object().shape({
	cautionaryNote: string().max(10000, "10000文字以内で設定してください"),
	noteTemplate: string().max(10000, "10000文字以内で設定してください"),
	noteWithinVendor: string().max(10000, "10000文字以内で設定してください")
});
